import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./AllForLucky.scss";
import { IUserLuckyOne } from "../../store/LuckyStore";
import intl from "react-intl-universal";
import moment from "moment";
import Mask from "../Mask";
import AllForForm from "../ComponentForm/AllForForm";
import "./MobileModal.scss";

export const NAME_MOBILE_TEMPLATE = (data: any) => {
  let expired = "";
  if (data) {
    if (moment(data.end_at).isValid()) {
      expired = moment(data.end_at).add(1, "d").format("YYYY-MM-DD HH:mm:ss");
    }
  }
  return {
    children: [
      {
        cid: `luck_template_0`,
        type: "richtext",
        container: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 10,
        },
        richtext: `
        <p style="text-align:center;" size="4" _root="" __ownerID="" __hash="" __altered="false"><span style="font-size:16px;color:var(--weui-FG-0)"><strong>领奖信息</strong></span></p>
        <p style="text-align:center;margin-bottom:0;" size="4" _root="" __ownerID="" __hash="" __altered="false"><span style="font-size:12px;color:var(--weui-FG-1)">请在${expired}前正确提交下方信息</span></p>
        <p style="text-align:center;margin-bottom:0;" size="4" _root="" __ownerID="" __hash="" __altered="false"><span style="font-size:12px;color:var(--weui-FG-1)">以便客服与您联系领取奖品，超时则无效</span></p>
      `,
      },
      Number(window.gallery.id) == 1049841
        ? {
            label: "工号",
            cid: `lucky_template_1`,
            type: "form_input",
            field: "工号",
            align: "left",
            required: true,
            width: "100%",
            placeholder: "请输入工号",
          }
        : {
            label: "姓名",
            cid: `lucky_template_1`,
            type: "form_input",
            field: "姓名",
            align: "left",
            required: true,
            width: "100%",
            placeholder: "请输入姓名",
          },
      {
        cid: `lucky_template_2`,
        type: "form_phone",
        field: "手机号",
        align: "left",
        required: true,
        width: "100",
        placeholder: "请输入手机号",
        whitelist: false,
        world: false,
      },
    ],
    container: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    submit: "提交",
    afteraction: "",
  };
};

const mobileModalRef = window.document.createElement("div");
mobileModalRef.className = "mobile-modal-portal";

const Index = (props: {
  formTemplate?: any;
  onSubmit: (data: any) => Promise<any> | undefined;
  visible: boolean;
  onClose: () => void;
}) => {
  const { formTemplate, onSubmit, visible, onClose } = props;

  useEffect(() => {
    if (visible) {
      window.document.body.appendChild(mobileModalRef);
    }

    return () => {
      if (mobileModalRef && mobileModalRef.parentNode) {
        mobileModalRef.parentNode.removeChild(mobileModalRef);
      }
    };
  }, [visible]);

  return visible
    ? createPortal(
        <>
          <Mask />
          <div className="lucky-mobile-modal">
            <div className="modal-content">
              <AllForForm {...formTemplate} customRequest={onSubmit} />
            </div>
            <a className="modal-close" onClick={onClose}>
              <img src={require("../../assets/x-36.png")} />
            </a>
          </div>
        </>,
        mobileModalRef
      )
    : null;
};

export default Index;
